export const formatCurrency = (value: number): string => {
    return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(value);
};

export const onlyNumbers = (value: string): string => value.replace(/\D/g, '');

export const formatCurrencyInput = (value: string): string => {
    const numeric = onlyNumbers(value);
    const numberValue = Number(numeric) / 100;
    return numberValue.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const parseCurrencyToNumber = (value: string): number => {
    if (!value) return 0;
    return Number(value.replace(/[^\d,-]/g, '').replace(',', '.'));
};

export const EXCEL_CURRENCY_FORMAT = '[$R$ ]#,##0.00'; 